/**
 * The message placeholders, and how to put one into a text box.
 *
 * THE LIST IS A PROMISE, KEPT BY THE SERVER. The CRM refuses to store a
 * template using anything else (`domain/config_rules.py`), and the messaging
 * service substitutes exactly these three (`domain/rendering.py`) — in a
 * template body and in free text alike, per recipient, so «سلام {{fullName}}»
 * sent to forty doctors greets each by their own name. This copy is only the
 * FALLBACK the chips render before the server's `validatePlaceholders` has
 * answered; whether a body is valid is always the server's call, never this
 * file's.
 */
export const ALLOWED_PLACEHOLDERS = ['firstName', 'lastName', 'fullName'];

export const placeholderToken = (name) => `{{${name}}}`;

/**
 * Insert `text` into `value` at the box's current selection, replacing it, and
 * say where the caret belongs afterwards. Pure: the caller sets the state and
 * moves the caret, because a controlled textarea only shows the new value on
 * the next render. With no element (the box is not mounted) it appends, which
 * is what the template editor always did.
 */
export function insertAtSelection(element, value, text) {
  const start = element?.selectionStart ?? value.length;
  const end = element?.selectionEnd ?? value.length;
  const next = `${value.slice(0, start)}${text}${value.slice(end)}`;
  return { value: next, caret: start + text.length };
}
